import { render } from "./Locations.vue?vue&type=template&id=6b4da193&scoped=true"
import script from "./Locations.vue?vue&type=script&lang=js"
export * from "./Locations.vue?vue&type=script&lang=js"

import "./Locations.vue?vue&type=style&index=0&id=6b4da193&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4da193"]])

export default __exports__